import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import ArrowRight from "../../public/assets/icons/arrowRight.svg";
import ArrowLeft from "../../public/assets/icons/arrowLeft.svg";
import styles from "./BoutiqueButton.module.scss";

const BoutiqueButton = ({
  data,
  ...props
}) => {
  const [hovered, setHovered] = useState(false);

  return (<>
  {data.links.length == 1 && <a
    href={data.links[0].url}
    target="_blank"
    rel="noreferrer"
    className={`${styles.BoutiqueButton}`}
    {...props}
  > <div>
      <span>Shop Online</span>
      
    </div>
  </a>}
  {data.links.length > 1 && <div
    className={`${styles.BoutiqueButton}`}
    {...props}

    onClick={e => {setHovered(!hovered); }}
    onMouseOver={e => setHovered(true)}
    onMouseOut={e => setHovered(false)}
  >
    <div>
      <span>Shop Online</span>
      
    </div>
    <div className={styles.submenu} style={{ display: hovered ? 'block' : 'none' }}>
      {data.links.map(l => <a key={l.url} rel="noreferrer" target="_blank" href={l.url}>{l.label}</a>)}
    </div>
  </div>}
</>)};

export default BoutiqueButton;